/* Assay, by Designs by Glide. Original work. Vanilla, no dependencies. */
(function () {
  'use strict';

  /* ---- Mobile menu -------------------------------------------------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
    });
  });

  /* ---- Announcement rotation ---------------------------------------- */
  document.querySelectorAll('[data-announcement-rotate]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var seconds = parseInt(bar.getAttribute('data-announcement-rotate'), 10) || 6;
    var i = 0;
    setInterval(function () {
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
    }, seconds * 1000);
  });

  /* ---- Product gallery ---------------------------------------------- */
  document.querySelectorAll('.product__thumbs').forEach(function (list) {
    var stage = document.getElementById('ProductStage');
    if (!stage) return;
    list.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-media-src]');
      if (!btn) return;
      stage.src = btn.getAttribute('data-media-src');
      stage.srcset = '';
      stage.alt = btn.getAttribute('data-media-alt') || '';
      list.querySelectorAll('[aria-current]').forEach(function (el) { el.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current', 'true');
    });
  });

  /* ---- Variant picker ------------------------------------------------ */
  document.querySelectorAll('.product__buy').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-data]');
    var idInput = root.querySelector('[data-variant-id]');
    var selects = root.querySelectorAll('[data-option-index]');
    if (!dataEl || !idInput || !selects.length) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var atc = root.querySelector('[data-atc]');
    var atcText = root.querySelector('[data-atc-text]');
    var priceBlock = document.querySelector('.product__price');
    /* Fall back to .price for a theme still on the old markup, so a stale
       price.liquid degrades to the previous behaviour instead of no update. */
    var amountHost = priceBlock && (priceBlock.querySelector('[data-price-amount]') || priceBlock.querySelector('.price'));
    var exHost = priceBlock && priceBlock.querySelector('[data-price-ex]');
    var wasHost = priceBlock && priceBlock.querySelector('[data-price-was]');
    var wasAmount = wasHost && wasHost.querySelector('[data-price-was-amount]');
    var stage = document.getElementById('ProductStage');

    function currency(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP'
        }).format(cents / 100);
      } catch (e) { return (cents / 100).toFixed(2); }
    }

    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return chosen.every(function (val, i) { return v.options[i] === val; });
      });

      if (!match) {
        if (atc) { atc.disabled = true; }
        if (atcText) { atcText.textContent = atcText.getAttribute('data-unavailable') || 'Unavailable'; }
        return;
      }

      idInput.value = match.id;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());

      if (atc) { atc.disabled = !match.available; }
      if (atcText) {
        atcText.textContent = match.available
          ? (atcText.getAttribute('data-add') || 'Add to cart')
          : (atcText.getAttribute('data-soldout') || 'Sold out');
      }
      if (amountHost) { amountHost.textContent = currency(match.price); }

      /* The ex-tax figure is the number a VAT registered buyer acts on, so it
         has to move with the variant. Mirror the Liquid arithmetic exactly:
         amount / divisor, rounded to whole pence, then formatted. */
      if (exHost) {
        var divisor = parseFloat(exHost.getAttribute('data-tax-divisor'));
        if (divisor > 0) {
          var template = exHost.getAttribute('data-ex-template') || '[price]';
          exHost.textContent = template.replace('[price]', currency(Math.round(match.price / divisor)));
        }
      }

      if (wasHost) {
        var was = match.compare_at_price;
        if (was && was > match.price) {
          if (wasAmount) { wasAmount.textContent = currency(was); }
          wasHost.hidden = false;
        } else {
          wasHost.hidden = true;
        }
      }
      if (stage && match.featured_image && match.featured_image.src) {
        stage.src = match.featured_image.src;
        stage.srcset = '';
      }
    }

    Array.prototype.forEach.call(selects, function (s) { s.addEventListener('change', update); });
  });

  /* ---- Add to cart (progressive enhancement over the real form) ------ */
  var form = document.getElementById('ProductForm');
  if (form) {
    form.addEventListener('submit', function (event) {
      if (!window.fetch) return; /* let the browser post the form */
      event.preventDefault();

      var btn = form.querySelector('[data-atc]');
      var errorEl = form.querySelector('[data-atc-error]');
      var label = form.querySelector('[data-atc-text]');
      var original = label ? label.textContent : '';

      if (btn) { btn.disabled = true; }
      if (label) { label.textContent = label.getAttribute('data-adding') || 'Adding…'; }
      if (errorEl) { errorEl.classList.add('visually-hidden'); errorEl.textContent = ''; }

      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
        .then(function (result) {
          if (!result.ok) { throw new Error(result.body && result.body.description ? result.body.description : 'Could not add to cart'); }
          if (label) { label.textContent = label.getAttribute('data-added') || 'Added'; }
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.hidden = cart.item_count === 0;
          });
          /* Anything listening (the cart drawer) can now show what went in. */
          document.dispatchEvent(new CustomEvent('cart:added', { detail: cart }));
          setTimeout(function () { if (label) { label.textContent = original; } }, 1800);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.classList.remove('visually-hidden'); }
          if (label) { label.textContent = original; }
        })
        .finally(function () { if (btn) { btn.disabled = false; } });
    });
  }

  /* ---- Facets: submit on change, no apply button needed -------------- */
  var facetForm = document.getElementById('FacetForm');
  if (facetForm) {
    facetForm.addEventListener('change', function () { facetForm.submit(); });
    var apply = facetForm.querySelector('.facets__actions .btn');
    if (apply) { apply.hidden = true; }
  }

  /* ---- Share: copy the link ------------------------------------------
     A readonly URL in a text input is the Dawn pattern and reads as
     unfinished. Native share sheet where the browser offers one, clipboard
     otherwise. Delegated, so it survives a Section Rendering API re-render. */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('button[data-share-url]') : null;
    if (!btn) return;

    var url = btn.getAttribute('data-share-url');
    var label = btn.querySelector('[data-share-label]');
    var original = label ? label.textContent : '';

    function confirmCopied() {
      if (!label) return;
      label.textContent = btn.getAttribute('data-copied-label') || 'Link copied';
      btn.setAttribute('data-copied', '');
      setTimeout(function () {
        label.textContent = original;
        btn.removeAttribute('data-copied');
      }, 2000);
    }

    /* Desktop Chrome defines navigator.share but answers it with an OS share
       dialog, which is a heavier thing than the person asked for. Offer the
       native sheet only on touch, where it is the better affordance, and copy
       everywhere else. */
    var touch = window.matchMedia && window.matchMedia('(any-pointer: coarse)').matches;

    if (touch && navigator.share) {
      navigator.share({ title: btn.getAttribute('data-share-title') || document.title, url: url })
        .catch(function () { /* dismissed, or unsupported payload: say nothing */ });
      return;
    }

    if (!navigator.clipboard) return; /* no clipboard: leave the label alone rather than lie */
    navigator.clipboard.writeText(url).then(confirmCopied, function () { /* denied */ });
  });

  /* ---- Product recommendations ---------------------------------------
     The section already rendered a collection-based fallback server-side,
     so this is an enhancement, not a dependency. Ask Shopify for real
     recommendations and swap them in only if it returns some; a store with
     no order history yet keeps the fallback rather than losing the band. */
  document.querySelectorAll('[data-recommendations]').forEach(function (root) {
    if (root.dataset.performed === 'true') return; /* already the API result */
    if (!window.fetch) return;

    fetch(root.dataset.url)
      .then(function (res) { return res.ok ? res.text() : Promise.reject(res.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (!fresh) return;
        /* Shopify returned no recommendations: keep the fallback on screen. */
        if (!fresh.querySelector('.card')) return;
        root.innerHTML = fresh.innerHTML;
        root.dataset.performed = 'true';
      })
      .catch(function () { /* keep the fallback */ });
  });

  /* ---- Desktop nav: open on hover as well as click --------------------
     The panels are <details>, which is click only. Click has to keep working:
     it is the keyboard and touch path, and WCAG 1.4.13 wants content shown on
     hover to be dismissible, which a real toggle gives for free. So hover is
     layered on top rather than replacing it.

     Gated on (hover: hover) and (pointer: fine), because a touch device
     synthesises mouseenter on tap and would open then immediately close.

     The close is delayed. The pointer crossing from the summary into the panel
     leaves the element for a frame, and closing instantly makes the menu feel
     like it is running away. A CSS hover bridge covers the gap; this covers the
     diagonal. */
  var navHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  if (navHover.matches) {
    var items = document.querySelectorAll('.header__item--has-children > details');
    items.forEach(function (d) {
      var closeTimer;
      var parent = d.parentElement;

      function open() {
        clearTimeout(closeTimer);
        items.forEach(function (other) { if (other !== d) other.open = false; });
        d.open = true;
      }
      function close(delay) {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
          if (d.contains(document.activeElement)) return; /* keyboard is in it */
          d.open = false;
        }, delay);
      }

      parent.addEventListener('mouseenter', open);
      parent.addEventListener('mouseleave', function () { close(180); });
      d.addEventListener('focusin', open);
      d.addEventListener('focusout', function (e) {
        if (!d.contains(e.relatedTarget)) d.open = false;
      });
    });

    /* Escape closes, which is the dismissible half of 1.4.13. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      items.forEach(function (d) {
        if (!d.open) return;
        d.open = false;
        var summary = d.querySelector('summary');
        if (summary && d.contains(document.activeElement)) summary.focus();
      });
    });
  }

  /* ---- Predictive search -------------------------------------------- */
  (function () {
    var overlay = document.getElementById('SearchOverlay');
    var opener = document.querySelector('[data-search-open]');
    /* No fetch, no overlay, no opener: the icon stays a link to /search. */
    if (!overlay || !opener || !window.fetch || !window.DOMParser) return;

    var input = document.getElementById('SearchOverlayInput');
    var results = document.getElementById('SearchOverlayResults');
    if (!input || !results) return;

    var endpoint = overlay.getAttribute('data-predictive-url') || '/search/suggest';
    var timer = null;
    var controller = null;
    var active = -1;
    var lastTerm = '';

    /* Announce the combobox only now that we know scripting works. Markup that
       claims to control a listbox which never updates is worse than none. */
    opener.setAttribute('aria-expanded', 'false');
    opener.setAttribute('aria-controls', 'SearchOverlay');
    opener.setAttribute('aria-haspopup', 'dialog');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', 'SearchOverlayResults');
    input.setAttribute('aria-autocomplete', 'list');
    results.setAttribute('role', 'listbox');

    function options() { return results.querySelectorAll('.search-result'); }

    function clear() {
      results.innerHTML = '';
      active = -1;
      input.removeAttribute('aria-activedescendant');
      input.setAttribute('aria-expanded', 'false');
    }

    function open(event) {
      if (event) event.preventDefault();
      overlay.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      input.focus();
      input.select();
      if (input.value.trim().length > 1) run(input.value.trim());
    }

    function close() {
      if (overlay.hidden) return;
      overlay.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      clear();
      opener.focus();
    }

    function highlight(next) {
      var opts = options();
      if (!opts.length) return;
      if (next < 0) next = opts.length - 1;
      if (next >= opts.length) next = 0;
      Array.prototype.forEach.call(opts, function (o) {
        o.removeAttribute('aria-selected');
        o.classList.remove('is-active');
      });
      active = next;
      opts[active].setAttribute('aria-selected', 'true');
      opts[active].classList.add('is-active');
      input.setAttribute('aria-activedescendant', opts[active].id);
      if (opts[active].scrollIntoView) opts[active].scrollIntoView({ block: 'nearest' });
    }

    function run(term) {
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = endpoint +
        '?q=' + encodeURIComponent(term) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(r.status)); })
        .then(function (html) {
          var block = new DOMParser().parseFromString(html, 'text/html')
            .getElementById('PredictiveSearchResults');
          results.innerHTML = block ? block.innerHTML : '';
          active = -1;
          input.removeAttribute('aria-activedescendant');
          /* aria-activedescendant needs a unique id per option, and the
             section cannot number collections and pages in one sequence. */
          Array.prototype.forEach.call(options(), function (o, i) {
            o.id = 'SearchResult-' + i;
          });
          input.setAttribute('aria-expanded', options().length ? 'true' : 'false');
        })
        .catch(function (err) {
          /* An aborted request is the expected case while someone is typing. */
          if (err && err.name === 'AbortError') return;
          clear();
        });
    }

    opener.addEventListener('click', open);

    overlay.addEventListener('click', function (event) {
      if (event.target.closest('[data-search-close]')) {
        event.preventDefault();
        close();
      }
    });

    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (timer) clearTimeout(timer);
      if (term.length < 2) { lastTerm = ''; clear(); return; }
      if (term === lastTerm) return;
      lastTerm = term;
      timer = setTimeout(function () { run(term); }, 200);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown') { event.preventDefault(); highlight(active + 1); }
      else if (event.key === 'ArrowUp') { event.preventDefault(); highlight(active - 1); }
      else if (event.key === 'Enter' && active > -1) {
        var opts = options();
        if (opts[active]) { event.preventDefault(); window.location.href = opts[active].href; }
      }
    });

    /* aria-modal="true" tells assistive tech the rest of the page is inert, so
       focus has to actually stay inside the panel. */
    overlay.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      var focusable = overlay.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    });
  })();

})();
